"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated HTMLElement has all these method built-in now
 */
class StyleUtil {
    /**
     * @deprecated Please use HTMLElement built in methods
     * @param elem
     * @param styleName
     * @param add
     */
    static setStyleName(elem, styleName, add) {
        if (elem) {
            const trimmedStyleName = styleName.trim();
            if (trimmedStyleName.length > 0) {
                if (add) {
                    StyleUtil.addClassName(elem, styleName);
                }
                else {
                    StyleUtil.removeStyleName(elem, styleName);
                }
            }
        }
    }
    /**
     * @deprecated Please use element.classList.add instead
     * @param element
     * @param className
     */
    static addClassName(element, className) {
        if (element) {
            if (element.className.split(" ").filter(value => value === className).length === 0) {
                element.className = element.className.trim() + " " + className;
            }
        }
    }
    /**
     * @deprecated Please use element.classList.remove instead
     * @param elem
     * @param styleName
     */
    static removeStyleName(elem, styleName) {
        if (elem) {
            const segments = elem.className.split(" ");
            const className = segments.filter((value) => value !== styleName).join(" ");
            elem.className = className;
        }
    }
    /**
     * @deprecated please use element.classList.contains instead
     * @param element
     * @param styleName
     */
    static hasStyleName(element, styleName) {
        if (element) {
            const segments = element.className.split(" ");
            for (let i = 0; i < segments.length; ++i) {
                const style = segments[i];
                if (styleName === style) {
                    return true;
                }
            }
        }
        return false;
    }
}
exports.default = StyleUtil;
//# sourceMappingURL=StyleUtil.js.map